import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { getHistory } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Expired = Loadable({
    loader: () => import('./Expired'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          couponExpiredState: state.couponExpiredState,
          siteConfig: state.siteConfig
        }),
        {
          languageChange,
          getHistory
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/expired`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Expired {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
